<template>
    <div id="dropdown" class="relative -mx-4">
        <div class="px-4">
            <button
                class="hidden sm:flex sm:items-center sm:w-full focus:outline-none"
                @click="opened = !opened"
            >
                <img src="/img/example-logo.svg" alt class="h-8 w-8 rounded-full object-cover" />
                <span
                    class="hidden lg:inline ml-4 mr-2 text-sm font-medium text-white"
                >{{ $auth.user().full_name }}</span>
                <svg
                    viewBox="0 0 24 24"
                    class="ml-2 h-6 w-6 fill-current text-gray-400 lg:ml-auto"
                >
                    <path
                        d="M7.293 9.293a1 1 0 011.414 0L12 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    />
                </svg>
            </button>
        </div>

        <div v-if="opened" @click="opened = false" class="fixed inset-0" tabindex="-1"></div>

        <transition
            enter-class="opacity-0 scale-90"
            enter-active-class="ease-out transition-fastest"
            enter-to-class="opacity-100 scale-100"
            leave-class="opacity-100 scale-100"
            leave-active-class="ease-in transition-fastest"
            leave-to-class="opacity-0 scale-90"
        >
            <div v-if="opened" class="mt-3 absolute left-0 origin-top-left z-50">
                <div class="w-64 text-left bg-white rounded-lg shadow-lg border">
                    <div class="py-1">
                        <router-link
                            :to="{ name: 'profile.edit' }"
                            class="block px-6 py-3 leading-tight hover:bg-gray-200"
                        >Настройки</router-link>
                    </div>

                    <div class="border-t-2 border-gray-200 py-1">
                        <button
                            @click="$auth.logout()"
                            class="block w-full px-6 py-3 text-left leading-tight hover:bg-gray-200"
                        >Выйти</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            opened: false
        };
    }
};
</script>
